"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Normal = Normal;
const unicode_arabic_1 = require("./unicode-arabic");
const unicode_ligatures_1 = require("./unicode-ligatures");
const isArabic_1 = require("./isArabic");
const reference_1 = require("./reference");
function Normal(word, breakPresentationForm) {
    // default is to turn initial/isolated/medial/final presentation form to generic
    if (typeof breakPresentationForm === 'undefined') {
        breakPresentationForm = true;
    }
    let returnable = '';
    word.split('').forEach((letter) => {
        if (!(0, isArabic_1.isArabic)(letter)) {
            returnable += letter;
            return;
        }
        for (let w = 0; w < reference_1.letterList.length; w++) {
            // ok so we are checking this potential lettertron
            let letterForms = unicode_arabic_1.default[reference_1.letterList[w]];
            let versions = Object.keys(letterForms);
            for (let v = 0; v < versions.length; v++) {
                let localVersion = letterForms[versions[v]];
                if (typeof localVersion === 'object' && typeof localVersion.indexOf === 'undefined') {
                    // look at this embedded object
                    let embeddedForms = Object.keys(localVersion);
                    for (let ef = 0; ef < embeddedForms.length; ef++) {
                        let form = localVersion[embeddedForms[ef]];
                        if (form === letter || (typeof form === 'object' && form.indexOf && form.indexOf(letter) > -1)) {
                            // match
                            // console.log('embedded match');
                            if (form === letter) {
                                // match exact
                                if (breakPresentationForm && localVersion['normal'] && ['isolated', 'initial', 'medial', 'final'].indexOf(embeddedForms[ef]) > -1) {
                                    // replace presentation form
                                    // console.log('keeping normal form of the letter');
                                    if (typeof localVersion['normal'] === 'object') {
                                        returnable += localVersion['normal'][0];
                                    }
                                    else {
                                        returnable += localVersion['normal'];
                                    }
                                    return;
                                }
                                // console.log('keeping this letter');
                                returnable += letter;
                                return;
                            }
                            else if (typeof form === 'object' && form.indexOf && form.indexOf(letter) > -1) {
                                // match
                                returnable += form[0];
                                // console.log('added the first letter from the same array');
                                return;
                            }
                        }
                    }
                }
                else if (localVersion === letter) {
                    // match exact
                    if (breakPresentationForm && letterForms['normal'] && ['isolated', 'initial', 'medial', 'final'].indexOf(versions[v]) > -1) {
                        // replace presentation form
                        // console.log('keeping normal form of the letter');
                        if (typeof letterForms['normal'] === 'object') {
                            returnable += letterForms['normal'][0];
                        }
                        else {
                            returnable += letterForms['normal'];
                        }
                        return;
                    }
                    // console.log('keeping this letter');
                    returnable += letter;
                    return;
                }
                else if (typeof localVersion === 'object' && localVersion.indexOf && localVersion.indexOf(letter) > -1) {
                    // match
                    returnable += localVersion[0];
                    // console.log('added the first letter from the same array');
                    return;
                }
            }
        }
        // try ligatures
        for (let v2 = 0; v2 < reference_1.ligatureList.length; v2++) {
            let normalForm = reference_1.ligatureList[v2];
            if (normalForm !== 'words') {
                let ligForms = Object.keys(unicode_ligatures_1.default[normalForm]);
                for (let f = 0; f < ligForms.length; f++) {
                    if (unicode_ligatures_1.default[normalForm][ligForms[f]] === letter) {
                        returnable += normalForm;
                        return;
                    }
                }
            }
        }
        // try words ligatures
        for (let v3 = 0; v3 < reference_1.ligatureWordList.length; v3++) {
            let normalForm = reference_1.ligatureWordList[v3];
            if (unicode_ligatures_1.default.words[normalForm] === letter) {
                returnable += normalForm;
                return;
            }
        }
        returnable += letter;
        // console.log('kept the letter')
    });
    return returnable;
}
